import React, { Component } from 'react';
import { post } from '../utils/request';
import queryString from 'query-string';
import { wxShare, isWeChat, deleteUrlKey, getParameterByName } from '../utils/util';

// component
import Banner from '../components/banner';
import Login from '../components/login';
import Intro from '../components/intro'; // banner 底部活动介绍
import TopDom from '../components/top'; // 菜单
import Dialog from '../components/dialog';
import AttService from '../components/attentionService'; // 报名成功后关注服务号
import SignButton from '../components/signInButton'; // 右下角 立即报名 按钮
import CourseReCom from '../components/courseRecommend'; // 推荐课程
import { UserInfoFa } from '../components/groupPerson';
import { ProjectInfoFa } from '../components/groupProject';
import { OtherInfo } from '../components/groupOther';

// todo move to groupProject
const PageIntro = () => {
  return (
    <div className="intro-content">
      <p>小饭桌ROADSHOW是小饭桌重磅推出的高质量创业项目路演活动，自2019年举办以来，一直致力于帮助优秀的创业项目精准、高效地对接一线投资机构。路演项目优质，匹配高效精准。</p>
      <p>感谢您百忙之中填写此报名表，为了提高投融资对接效率，请您认真填写相关信息，填写不完整将影响审核进度。</p>
      <p>请优先使用电脑端填写，手机端上传BP需添加工作人员微信，备注“姓名-BP”提交。如有疑问，请联系小饭桌工作人员，手机同微信号：13810700473。</p>
    </div>
  )
}

class Class extends Component {
  constructor (props) {
    super(props);
    // 报名表信息
    this.state = {
      checkErr: false, // 检测表单数据
      hasLogin: false, // 默认没登录的情况下不会出现表单
      currentPageInfo: {}, // 页面基础信息
      endGetPage: false, // 页面基本信息获取完毕
      endGetUserInfo: false, // 页面表单信息获取完毕
      userInfo: {}, // 用户基本信息和项目信息
      showServiceDialog: false,// 展示服务号关注二维码
      wechatDialogJson: {}, // 服务号传送json
      commitFlag: true, // commit Flag
      idObj: {
        uid: '',
        phone: '',
        en_id: '',
        project_id: '',
      },
    }
    this.loginInfo = {      // login登录组件信息
      urlValues: '',
      userLoginInfo: {}
    }
    // 其他问题组件
    this.resApplyData = {
      answers: []
    };
  }
  componentDidMount () {
    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;
    this.loginInfo.urlValues = urlValues; // 传值给login组件
    this.getPageInfo();
    window.addEventListener('scroll', this.handelScroll);
    // this.state.checkErr = true
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handelScroll);
  }
  handelScroll = () => {
    const t = document.documentElement.scrollTop || document.body.scrollTop;
    const top_view = document.getElementsByClassName('sign-fix-button')[0];
    const intro_view = document.getElementById('form-start');
    if (top_view && top_view !== null && intro_view && intro_view !== null) {
      top_view.style.display = t >= (intro_view.offsetTop - 500) ? 'none' : 'block';
    }
  }
  getPageInfo = () => {
    document.title = "小饭桌创投会项目报名表"

    // wechat share
    let wxDes = '请优先使用电脑填写此报名表。';
    this.wxTitle = "小饭桌创投会项目报名表";
    this.wxDes = wxDes;

    wxShare(this.wxTitle , wxDes);

    let _data = {
       // 'top_pc_banner': 'https://static-image.xfz.cn/fa-new-banner.jpg',
       // 'top_pc_banner': 'https://static-miniapp.xfz.cn/1920.jpg',
       // 'top_pc_banner': 'https://static-image.xfz.cn/1632787831854/2021_road.jpeg',
       // 'top_pc_banner':'https://static-image.xfz.cn/1635430858761/rs_2021.jpg',
       // 'top_pc_banner':'https://static-image.xfz.cn/1645506617844/2022_rs.jpg',
       'top_pc_banner':'https://static-image.xfz.cn/1648116029741/rs_22_3.JPG',
       
       'apply_title': '',
    }

    // storage
    localStorage.removeItem('formPageSto');
    localStorage.setItem('formPageSto', JSON.stringify({
      banner: _data.top_pc_banner,
      from: 'class',
      title: _data.apply_title,
      shareUrl: deleteUrlKey('code')
    }))

    // change state
    this.setState({
      currentPageInfo: {'top_pc_banner': _data.top_pc_banner},
      endGetPage: 'end',
    })
  }
  getFaUserInfo = (phone) => {
    // var _idObj = {...this.state.idObj}
    post('/fancube/apply/v2/financing/en/', {
      "phone": phone
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          userInfo: res.data,
          endGetUserInfo: 'end',
          idObj: {
            ...this.state.idObj,
            en_id: res.data.entrepreneur.en_id,
            project_id: res.data.project.project_id
          }
        })
      }
    })
  }
  getUserData = (resPonUserData) => {
    this.setState({
      resPonUserData
    })
  }
  getProjectData = (resProjectData) => {
    this.setState({
      resProjectData
    })
  }
  getApplyData = (resApplyData) => {
    this.resApplyData = resApplyData;
  }
  getLoginData = (resLoginData) => {
    this.resLoginData = resLoginData;
    this.setState({
      hasLogin: resLoginData.hasLogin,
      openId: resLoginData.openid,
      idObj: {
        uid: resLoginData.userLoginInfo.uid, 
        phone: resLoginData.userLoginInfo.phone, 
      }
    }, () => {
      if (this.state.hasLogin) {
        // 登录成功后获取页面个人信息

        // fa 投融资报名
        this.getFaUserInfo(resLoginData.userLoginInfo.phone);
        // this.getUserInfo(resLoginData.userLoginInfo.phone);

        // 传参给服务号二维码组件
        let wechatDialogJson = {
          'code': this.pageUrlValues.acid
        }
        if (isWeChat() && this.state.openId ) {
          wechatDialogJson['openid'] = this.state.openId;
        }
        this.setState({
          wechatDialogJson: wechatDialogJson
        })

        let wxUrl = resLoginData.userLoginInfo.uid ? deleteUrlKey('code') + `&invite=${resLoginData.userLoginInfo.uid}` : '';

        if (isWeChat() && wxUrl) {
          wxShare(this.wxTitle, this.wxDes, wxUrl);
          // storage
          localStorage.removeItem('formPageSto');
          localStorage.setItem('formPageSto', JSON.stringify({
            banner: this.state.currentPageInfo.top_pc_banner,
            from: 'class',
            title: this.state.currentPageInfo.apply_title,
            shareUrl: wxUrl
          }))
        }
      }
    })
  }
  getAttService = (resAttService) => {
    this.setState({
      subscribe: resAttService.subscribe
    })
  }
  // fa 投融资报名表
  ajaxFaSubmitData = () => {
    this.state.resPonUserData.status = this.state.resProjectData.status;
    this.state.resPonUserData.position = this.state.resProjectData.position;
    var _u = this.state.resPonUserData.isRight
    var _p = this.state.resProjectData.isRight 

    // console.log('--- user is right ---' + _u)
    // console.log('--- project is right ---' + _p)

    if (this.state.resPonUserData.isRight && this.state.resProjectData.isRight && this.state.commitFlag) {

      this.setState({
        commitFlag: false
      })

      if (this.state.idObj.en_id) { this.state.resPonUserData.en_id = this.state.idObj.en_id }
      if (this.state.idObj.project_id) { this.state.resProjectData.project_id = this.state.idObj.project_id }

      post('/fancube/apply/v2/financing/submit/', {
        "project": this.state.resProjectData,
        "entrepreneur": this.state.resPonUserData,
        "uid": this.resLoginData.userLoginInfo.uid,
      }).then(res => {
        this.setState({
          commitFlag: true
        })
        if (res.code === 200) {
            const { history } = this.props;
            const location = {
              pathname: '/successFa'
            }
            history.push(location);
        }
      })
    }
  }
  handleFaSubmit = () => {
    this.setState({
      checkErr: true
    })
    this.ajaxFaSubmitData();
  }
  render () {
    let changeJson = {};
    if (this.state.endGetUserInfo && this.state.userInfo.entrepreneur) {
      changeJson = {
        "position": this.state.userInfo.entrepreneur.position,
      };
    }
    return (
      <div className="class-wrapper page-wrapper">
        {
          this.state.endGetPage &&
          <div className="end-wrapper">
            <TopDom />
            <Banner url={this.state.currentPageInfo.top_pc_banner} />
            <PageIntro />
            <div id="form-start"></div>
            {
             this.state.isCourseOut ? 
             <CourseReCom/> : 
             <Login 
              {...this.loginInfo} 
              type={this.state.currentPageInfo.type} 
              receiveData={this.getLoginData} />
            }
            {
              this.state.hasLogin && this.state.endGetUserInfo &&
              <div className="form-info-wrapper">
                <div className="form-title">填写报名信息</div>
                <UserInfoFa 
                  { ...this.state.userInfo.entrepreneur } 
                  checkErr={ this.state.checkErr } 
                  receiveData={ this.getUserData } 
                  receiveLogoutData={ this.getLoginData }/>
                <ProjectInfoFa 
                  { ... this.state.userInfo.project } 
                  { ... changeJson } 
                  idObj={this.state.idObj}
                  checkErr={ this.state.checkErr } 
                  receiveData={ this.getProjectData }/>
                <Dialog isShow={ this.state.showServiceDialog }>
                  <AttService 
                    receiveData={ this.getAttService } 
                    isShowDia={ this.state.showServiceDialog } 
                    history={ this.props.history } 
                    { ...this.state.wechatDialogJson }/>
                </Dialog>
                { this.state.checkErr && 
                  (!this.state.resPonUserData.isRight || !this.state.resProjectData.isRight) && 
                  <p className="err-bottom-tips">请完善相关资料</p>
                }
                <div className={this.state.commitFlag ? "submit-form l-button" : "submit-form l-button disabled"} 
                  onClick={ this.handleFaSubmit }>
                  {this.state.commitFlag ? '立即报名' : '正在提交...'}
                </div>
              </div>
            }
          </div>
        }
        { this.pageUrlValues && this.pageUrlValues.intro && 
          <SignButton 
            scrollId="form-start" 
            isCourse={this.state.isCourseOut ? true : false}/> 
        }
      </div>
    )
  }
}
export default Class;
